'use client';

import { useState } from 'react';

import { Badge, Button, Drawer, Icon, Stack, Text } from '@backyard-ui/core';
import { ShoppingCartOutline } from '@backyard-ui/icons';

import { algolia } from '@/infra/tracking/algolia';
import { useProductStore } from '@/presenters/store/catalog/product';

import { BuyButtons } from '../BuyButtons';

import { Item } from './Item';
import { Skeleton } from './Skeleton';
import useStoreStock from './useStoreStock';

const LEROY_SELLER_ID = 'leroy';

const StoreStockDrawer = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { _id, name } = useProductStore((state) => state.product);
  const sellerId = useProductStore((state) => state.currentSeller.shop.id);

  const {
    data: response,
    isFetching,
    isLoading,
  } = useStoreStock(
    {
      itemId: _id,
    },
    {
      enabled: isDrawerOpen,
      staleTime: Infinity,
    }
  );

  const stores = response?.data?.stores || [];
  const ecommerce = response?.data?.ecommerce;
  const isDisabled = sellerId !== LEROY_SELLER_ID;

  return (
    <Drawer.Root isOpen={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <Drawer.Trigger asChild>
        <Button
          variant="outline"
          isDisabled={isDisabled}
          isFullWidth
          data-gtm-element="Stock Availability Button"
          onClick={() => {
            algolia.sendPdpClickEvent();
          }}
        >
          Ver estoque nas lojas físicas
        </Button>
      </Drawer.Trigger>

      <Drawer.Content data-testid="stock-drawer">
        <Drawer.CloseButton />

        <Drawer.Title UNSAFE_className="flex flex-col gap-2">
          Disponibilidade de estoque
          <Text size="sm" color="neutral-700" asChild>
            <span>Selecione a loja em que deseja retirar este produto</span>
          </Text>
        </Drawer.Title>

        <Drawer.Description>
          {isFetching || isLoading ? (
            <Skeleton />
          ) : (
            <Stack direction="column" spacing="6">
              <Stack direction="column" spacing="2" align="flex-start">
                <Text weight="bold">{name}</Text>

                <Badge appearance="neutral" variant="subtle">
                  Cód. {_id}
                </Badge>
              </Stack>

              <Stack direction="column" spacing="2">
                <Stack spacing="2">
                  <Icon>
                    <ShoppingCartOutline />
                  </Icon>

                  <Text weight="bold">Site Leroy Merlin</Text>
                </Stack>

                <Text size="sm" data-testid="ecommerce-stock">
                  {ecommerce?.stock ? (
                    <>
                      <strong>{response?.data.ecommerce.stock}</strong> peças em
                      estoque
                    </>
                  ) : (
                    ecommerce?.message
                  )}
                </Text>
              </Stack>
              <BuyButtons size="xs" />
              {stores.map((store) => (
                <Item key={store.id} store={store} />
              ))}
            </Stack>
          )}
        </Drawer.Description>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default StoreStockDrawer;
